import { isDomainEnabled } from './isDomainEnabled';
import { getDomainFromResource } from './getDomainFromResource';

/**
 * @group Functions
 * 
 * @summary
 * <blockquote>Check if a resource is enabled for logging in current environment</blockquote>
 * 
 * @param resource - The resource name
 * @returns True if the resource's domain is enabled for logging
 * 
 * @example
 * ```typescript
 * const isEnabled = isResourceEnabled('db_users'); // boolean
 * ```
 **/
export const isResourceEnabled = (resource: string): boolean => {
  const domain = getDomainFromResource(resource);
  return isDomainEnabled(domain);
}; 